import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};



export type AddAttachmentInput = {
  contentType: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type AddNoteInput = {
  attachments?: Maybe<Array<NestedAttachmentInput>>;
  incidentId: Scalars['String'];
  text: Scalars['String'];
};

export type Analytics = {
  __typename?: 'Analytics';
  assignees?: Maybe<Array<User>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  firstRead?: Maybe<Scalars['DateTime']>;
  fraud: Scalars['Boolean'];
  /** The incident parent */
  incident?: Maybe<Incident>;
  status: Status;
  tags?: Maybe<Array<Tag>>;
  timeToCloseHours?: Maybe<Scalars['Float']>;
  timeToFirstReadHours?: Maybe<Scalars['Float']>;
};

export type AnalyticsProcessedDataResponse = {
  __typename?: 'AnalyticsProcessedDataResponse';
  casesByMonths?: Maybe<Array<CasesByMonthsAnalytics>>;
  categories?: Maybe<Array<CategoriesAnalytics>>;
  dashboard?: Maybe<DashboardAnalytics>;
  groups?: Maybe<Array<GroupsAnalytics>>;
  performance?: Maybe<Array<PerformanceAnalytics>>;
  workspaces?: Maybe<Array<WorkspacesAnalytics>>;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AttachmentInput = {
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AuditChange = {
  __typename?: 'AuditChange';
  event?: Maybe<Scalars['String']>;
  metaData?: Maybe<Array<Scalars['String']>>;
  property?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
};

export type AuditTrailResponse = {
  __typename?: 'AuditTrailResponse';
  changes?: Maybe<Array<AuditChange>>;
  className: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType: Scalars['String'];
  id: Scalars['String'];
  objectId: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CasesByMonthsAnalytics = {
  __typename?: 'CasesByMonthsAnalytics';
  monthNumber?: Maybe<Scalars['Float']>;
  monthOrder?: Maybe<Scalars['Float']>;
  totalCaseNumber?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type CategoriesAnalytics = {
  __typename?: 'CategoriesAnalytics';
  categoryId?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  totalCaseNumber?: Maybe<Scalars['Float']>;
};

/** This resembles an entry in the conversation between reporter and NW bot. The different types can have the bot display different kinds of answer options */
export type ConversationEntry = {
  __typename?: 'ConversationEntry';
  botText: Scalars['String'];
  type: ConversationEntryType;
};

export type ConversationEntryInput = {
  botText: Scalars['String'];
  type?: Maybe<ConversationEntryType>;
};

/** The different types can have the bot display different kinds of answer options. */
export enum ConversationEntryType {
  NoAnswer = 'NO_ANSWER',
  Text = 'TEXT',
  UserList = 'USER_LIST',
  YesNo = 'YES_NO'
}

export type CreateIncidentResponse = {
  __typename?: 'CreateIncidentResponse';
  incident: Incident;
  viewPassword?: Maybe<Scalars['String']>;
};

export type DashboardAnalytics = {
  __typename?: 'DashboardAnalytics';
  avTimeHandling?: Maybe<Scalars['Float']>;
  avTimeRead?: Maybe<Scalars['Float']>;
  casesWithinDeadline?: Maybe<Scalars['Float']>;
  deadlineCases?: Maybe<Scalars['Float']>;
  openCases?: Maybe<Scalars['Float']>;
};


/** Various document texts */
export type DocumentText = {
  __typename?: 'DocumentText';
  createdAt?: Maybe<Scalars['DateTime']>;
  edited?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isFirstTimeEdit?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<DocumentTextType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentTextInput = {
  edited: Scalars['Boolean'];
  isFirstTimeEdit: Scalars['Boolean'];
  language: Scalars['String'];
  text: Scalars['String'];
  type?: Maybe<DocumentTextType>;
};

/** The supported document text types. */
export enum DocumentTextType {
  LandingPageDetails = 'LANDING_PAGE_DETAILS',
  LandingPageIntroduction = 'LANDING_PAGE_INTRODUCTION',
  PersonalDataManagementPolicy = 'PERSONAL_DATA_MANAGEMENT_POLICY'
}

export type Group = {
  __typename?: 'Group';
  categoryRouting?: Maybe<Array<Tag>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GroupInput = {
  categoryRouting?: Maybe<Array<TagInput>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GroupsAnalytics = {
  __typename?: 'GroupsAnalytics';
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  totalCaseNumber?: Maybe<Scalars['Float']>;
};

/** Hide personal data management policy link for language */
export type HidePersonalDataManagementPolicyLink = {
  __typename?: 'HidePersonalDataManagementPolicyLink';
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type HidePersonalDataManagementPolicyLinkInput = {
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type Incident = {
  __typename?: 'Incident';
  assignees?: Maybe<Array<User>>;
  caseId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  firstMessage?: Maybe<Scalars['String']>;
  firstRead?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  readByMe?: Maybe<Scalars['Boolean']>;
  readByRoles?: Maybe<Array<Scalars['String']>>;
  restrictedUsers?: Maybe<Array<RestrictedUser>>;
  status: Status;
  submissions?: Maybe<Array<Submission>>;
  tags?: Maybe<Array<Tag>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IncidentExportItemsInput = {
  auditLog: Scalars['Boolean'];
  caseFiles: Scalars['Boolean'];
  dialogue: Scalars['Boolean'];
  workNotes: Scalars['Boolean'];
  workNotesFiles: Scalars['Boolean'];
};

export type IncidentInput = {
  assignees?: Maybe<Array<UserInput>>;
  caseId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  firstMessage?: Maybe<Scalars['String']>;
  firstRead?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  readByRoles?: Maybe<Array<Scalars['String']>>;
  restrictedUsers?: Maybe<Array<RestrictedUserInput>>;
  status: Status;
  submissions?: Maybe<Array<SubmissionInput>>;
  tags?: Maybe<Array<TagInput>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IncidentWithMessage = {
  __typename?: 'IncidentWithMessage';
  incident: Incident;
  message: Message;
};

/** Tenants has been verified to belong to the same organization */
export type LinkedTenants = {
  __typename?: 'LinkedTenants';
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type LinkedTenantsInput = {
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  /** The incident parent */
  incident?: Maybe<Incident>;
  /** Not in use */
  parentId?: Maybe<Scalars['String']>;
  readByMe?: Maybe<Scalars['Boolean']>;
  readByRoles?: Maybe<Array<Scalars['String']>>;
  /** Defines who sent this message: BOT | REPORTER | ADMIN */
  sender: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  /** Defines the source channel of this message, e.g. from APP, SMS.... */
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageInput = {
  attachments?: Maybe<Array<AttachmentInput>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  /** The incident parent */
  incident?: Maybe<IncidentInput>;
  /** Not in use */
  parentId?: Maybe<Scalars['String']>;
  readByRoles?: Maybe<Array<Scalars['String']>>;
  /** Defines who sent this message: BOT | REPORTER | ADMIN */
  sender: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  /** Defines the source channel of this message, e.g. from APP, SMS.... */
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAnonymousMessage: Message;
  addMessage: Message;
  addNoteToIncident: Note;
  addUsersToGroup: Array<User>;
  createAnonymousIncident: CreateIncidentResponse;
  createCategory: Tag;
  createDocumentText: DocumentText;
  createGroup: Group;
  createIncident: CreateIncidentResponse;
  createUsers: Array<User>;
  deleteGroup: Scalars['Boolean'];
  deleteNote: Scalars['Boolean'];
  deleteTag: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  incidentSetStatusWithMessage: IncidentWithMessage;
  resetToDefaultCategoriesInLanguage: Scalars['Boolean'];
  sendPasswordResetLink: Scalars['Boolean'];
  updateAssignees: Incident;
  updateDocumentText: DocumentText;
  updateGroup: Group;
  updateNote: Note;
  updateRedirectRule: RedirectRuleGraphql;
  updateReporterSettings: ReporterSettings;
  updateTag: Tag;
  updateTenant: Tenant;
  updateUser: User;
};


export type MutationAddAnonymousMessageArgs = {
  fileUploads: Array<AddAttachmentInput>;
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  text: Scalars['String'];
};


export type MutationAddMessageArgs = {
  fileUploads: Array<AddAttachmentInput>;
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  text: Scalars['String'];
};


export type MutationAddNoteToIncidentArgs = {
  addNoteInput: AddNoteInput;
};


export type MutationAddUsersToGroupArgs = {
  group: GroupInput;
  users: Array<UserInput>;
};


export type MutationCreateAnonymousIncidentArgs = {
  firstMessage: Scalars['String'];
  reporterPhone?: Maybe<Scalars['String']>;
  restrictedUsers?: Maybe<Array<RestrictedUserInput>>;
  submissions: Array<SubmissionInput>;
  tags: Array<TagInput>;
};


export type MutationCreateCategoryArgs = {
  category: TagInput;
};


export type MutationCreateDocumentTextArgs = {
  createDocumentTextInput: Array<DocumentTextInput>;
};


export type MutationCreateGroupArgs = {
  name: Scalars['String'];
};


export type MutationCreateIncidentArgs = {
  firstMessage: Scalars['String'];
  submissions: Array<SubmissionInput>;
  tags: Array<TagInput>;
};


export type MutationCreateUsersArgs = {
  userNames: Array<Scalars['String']>;
};


export type MutationDeleteGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNoteArgs = {
  noteId: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  tag: TagInput;
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String'];
};


export type MutationIncidentSetStatusWithMessageArgs = {
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  status: Status;
  text: Scalars['String'];
};


export type MutationResetToDefaultCategoriesInLanguageArgs = {
  language: ReporterLanguageInput;
};


export type MutationSendPasswordResetLinkArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateAssigneesArgs = {
  assignees: Array<UserInput>;
  incidentId: Scalars['String'];
};


export type MutationUpdateDocumentTextArgs = {
  updateDocumentTextInput: DocumentTextInput;
};


export type MutationUpdateGroupArgs = {
  group: GroupInput;
};


export type MutationUpdateNoteArgs = {
  noteInput: UpdateNoteInput;
};


export type MutationUpdateRedirectRuleArgs = {
  redirectRule: RedirectRuleGraphqlInput;
};


export type MutationUpdateReporterSettingsArgs = {
  reporterSettings: ReporterSettingsInput;
};


export type MutationUpdateTagArgs = {
  tag: TagInput;
};


export type MutationUpdateTenantArgs = {
  locale: Scalars['String'];
  mfa?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};

export type NestedAttachment = {
  __typename?: 'NestedAttachment';
  contentType?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NestedAttachmentInput = {
  contentType?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Note = {
  __typename?: 'Note';
  attachments?: Maybe<Array<NestedAttachment>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  incident: Incident;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type NoteInput = {
  attachments?: Maybe<Array<NestedAttachmentInput>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  incident: IncidentInput;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserInput>;
};

export type OneTimeCode = {
  __typename?: 'OneTimeCode';
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type PerformanceAnalytics = {
  __typename?: 'PerformanceAnalytics';
  avTimeHandling?: Maybe<Scalars['Float']>;
  avTimeRead?: Maybe<Scalars['Float']>;
  casesWithinDeadline?: Maybe<Scalars['Float']>;
  totalCaseNumber?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type PlanGraphql = {
  __typename?: 'PlanGraphql';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
  prices: Array<PriceGraphql>;
  trial: Scalars['Boolean'];
  trialDays: Scalars['Float'];
};

export type PriceGraphql = {
  __typename?: 'PriceGraphql';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  recurrenceInterval: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  exportIncident: Scalars['Boolean'];
  getAllDocumentTextForTenant: Array<DocumentText>;
  getAllDocumentTextForTenantAnonymous: Array<DocumentText>;
  getAnalytics: Array<Analytics>;
  getAnalyticsProcessedData: AnalyticsProcessedDataResponse;
  getAttachmentsByIncidentId: Array<Attachment>;
  getAuditLog: Array<AuditTrailResponse>;
  getAuditLogV2: Array<SimpleAuditEntry>;
  getCustomerPortal: Scalars['String'];
  getFileAttachmentsByIncidentId: Array<Attachment>;
  getIncident: Incident;
  getIncidentByCaseId: Incident;
  getIncidentByOneTimeCodeAndCaseId: Incident;
  getMediaAttachmentsByIncidentId: Array<Attachment>;
  getMessagesByIncidentId: Array<Message>;
  getMessagesByOneTimeCodeAndCaseId: Array<Message>;
  getNotesByIncidentId: Array<Note>;
  getOneTimeCodeForIncidentByPassword: OneTimeCode;
  getOneTimeCodeForIncidentByPhone: Scalars['Boolean'];
  getReporterEnabledLanguages: Array<ReporterLanguage>;
  getReporterSettingsAnonymous: ReporterSettings;
  getSettings: Settings;
  getTag: Tag;
  getTenant: Tenant;
  getTenantAnonymous: TenantAnonymous;
  listActiveCategories: Array<Tag>;
  listActiveCategoriesAnonymous: Array<Tag>;
  listCategories: Array<Tag>;
  listCategoriesAnonymous: Array<Tag>;
  listGroups: Array<Group>;
  listIncidents: Array<Incident>;
  listRedirectRules: Array<RedirectRuleGraphql>;
  listUsers: Array<User>;
  listUsersAnonymous: Array<RestrictedUser>;
  translateMessage: Scalars['String'];
  translateMessageAnonymous: Scalars['String'];
};


export type QueryExportIncidentArgs = {
  caseId: Scalars['String'];
  exportItems: IncidentExportItemsInput;
  incidentId: Scalars['String'];
};


export type QueryGetAllDocumentTextForTenantAnonymousArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetAnalyticsProcessedDataArgs = {
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  isExtended: Scalars['Boolean'];
  tenantIds: Array<Scalars['String']>;
  type: Scalars['String'];
};


export type QueryGetAttachmentsByIncidentIdArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetAuditLogArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetAuditLogV2Args = {
  incidentId: Scalars['String'];
};


export type QueryGetFileAttachmentsByIncidentIdArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetIncidentArgs = {
  id: Scalars['String'];
};


export type QueryGetIncidentByCaseIdArgs = {
  caseId: Scalars['String'];
};


export type QueryGetIncidentByOneTimeCodeAndCaseIdArgs = {
  caseId: Scalars['String'];
  oneTimeCode: Scalars['String'];
};


export type QueryGetMediaAttachmentsByIncidentIdArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetMessagesByIncidentIdArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetMessagesByOneTimeCodeAndCaseIdArgs = {
  caseId: Scalars['String'];
  oneTimeCode: Scalars['String'];
};


export type QueryGetNotesByIncidentIdArgs = {
  incidentId: Scalars['String'];
};


export type QueryGetOneTimeCodeForIncidentByPasswordArgs = {
  caseId: Scalars['String'];
  password: Scalars['String'];
};


export type QueryGetOneTimeCodeForIncidentByPhoneArgs = {
  caseId: Scalars['String'];
  reporterPhone: Scalars['String'];
};


export type QueryGetReporterSettingsAnonymousArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetTagArgs = {
  id: Scalars['String'];
};


export type QueryListIncidentsArgs = {
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  categoryIds?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryTranslateMessageArgs = {
  message: Scalars['String'];
};


export type QueryTranslateMessageAnonymousArgs = {
  message: Scalars['String'];
};

export type RedirectRuleGraphql = {
  __typename?: 'RedirectRuleGraphql';
  anonymous?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  targets?: Maybe<Array<RedirectTargetGrapqh>>;
};

export type RedirectRuleGraphqlInput = {
  anonymous?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  targets?: Maybe<Array<RedirectTargetGrapqhInput>>;
};

export type RedirectTargetGrapqh = {
  __typename?: 'RedirectTargetGrapqh';
  available?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type RedirectTargetGrapqhInput = {
  available?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** Defines elements on personal landing page to be colored */
export type ReporterBrandColor = {
  __typename?: 'ReporterBrandColor';
  button?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type ReporterBrandColorInput = {
  button?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

/** Reporter language */
export type ReporterLanguage = {
  __typename?: 'ReporterLanguage';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ReporterLanguageInput = {
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** The supported reporter login types. */
export enum ReporterLoginType {
  Password = 'PASSWORD',
  Phone = 'PHONE'
}

/** Tenant ReporterSettingsInput */
export type ReporterSettings = {
  __typename?: 'ReporterSettings';
  brandColor?: Maybe<ReporterBrandColor>;
  companyLogo?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  dataProtectionOfficer?: Maybe<Scalars['String']>;
  hidePersonalDataManagementPolicyLink?: Maybe<Array<HidePersonalDataManagementPolicyLink>>;
  languages?: Maybe<Array<ReporterLanguage>>;
  loginType?: Maybe<ReporterLoginType>;
  phoneHotlineNumber?: Maybe<Scalars['String']>;
  responsiblePersonForWhistleblowing?: Maybe<Scalars['String']>;
  type?: Maybe<ReporterType>;
};

export type ReporterSettingsInput = {
  brandColor?: Maybe<ReporterBrandColorInput>;
  companyLogo?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  dataProtectionOfficer?: Maybe<Scalars['String']>;
  hidePersonalDataManagementPolicyLink?: Maybe<Array<HidePersonalDataManagementPolicyLinkInput>>;
  languages?: Maybe<Array<ReporterLanguageInput>>;
  loginType?: Maybe<ReporterLoginType>;
  phoneHotlineNumber?: Maybe<Scalars['String']>;
  responsiblePersonForWhistleblowing?: Maybe<Scalars['String']>;
  type?: Maybe<ReporterType>;
};

/** The supported reporter types. */
export enum ReporterType {
  Chat = 'CHAT',
  Form = 'FORM'
}

/** If id is set this user should be blocked from getting access now and in the future */
export type RestrictedUser = {
  __typename?: 'RestrictedUser';
  fullName?: Maybe<Scalars['String']>;
  /** If id is null, this user has been added by name if not, it has been selected in a user list */
  id?: Maybe<Scalars['String']>;
};

export type RestrictedUserInput = {
  fullName?: Maybe<Scalars['String']>;
  /** If id is null, this user has been added by name if not, it has been selected in a user list */
  id?: Maybe<Scalars['String']>;
};

/** Tenant Settings */
export type Settings = {
  __typename?: 'Settings';
  id?: Maybe<Scalars['String']>;
  linkedTenants?: Maybe<Array<LinkedTenants>>;
  reporter: ReporterSettings;
};

export type SettingsInput = {
  id?: Maybe<Scalars['String']>;
  linkedTenants?: Maybe<Array<LinkedTenantsInput>>;
  reporter: ReporterSettingsInput;
};

export type SimpleAuditEntry = {
  __typename?: 'SimpleAuditEntry';
  date?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

/** The supported statuses. */
export enum Status {
  Closed = 'CLOSED',
  New = 'NEW',
  Open = 'OPEN',
  PendingDeletion = 'PENDING_DELETION'
}

export type Submission = {
  __typename?: 'Submission';
  answer?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<NestedAttachment>>;
  question?: Maybe<Scalars['String']>;
};

export type SubmissionInput = {
  answer?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<NestedAttachmentInput>>;
  question?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  /** Allow exclude tag from Reporter, but remain it in the tag list in admin. Can be used for example to create tag draft to adjust required information before tag will be available on the reporter. */
  active?: Maybe<Scalars['Boolean']>;
  /** Tags that are categories will be used for routing and initial case tagging, they also holds the conversational flow configuration. You should not use multiple category tags on the same instance */
  category?: Maybe<Scalars['Boolean']>;
  /** Only tags that are categories will also have a conversational flow */
  conversationalFlow?: Maybe<Array<ConversationEntry>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  /** For UI ordering purposes, can be any number and relates to other instances in lists */
  order?: Maybe<Scalars['Float']>;
  /** Only tags that are not unchangeable available for update */
  unchangeable?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagInput = {
  /** Allow exclude tag from Reporter, but remain it in the tag list in admin. Can be used for example to create tag draft to adjust required information before tag will be available on the reporter. */
  active?: Maybe<Scalars['Boolean']>;
  /** Tags that are categories will be used for routing and initial case tagging, they also holds the conversational flow configuration. You should not use multiple category tags on the same instance */
  category?: Maybe<Scalars['Boolean']>;
  /** Only tags that are categories will also have a conversational flow */
  conversationalFlow?: Maybe<Array<ConversationEntryInput>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  /** For UI ordering purposes, can be any number and relates to other instances in lists */
  order?: Maybe<Scalars['Float']>;
  /** Only tags that are not unchangeable available for update */
  unchangeable?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TaxGraphql = {
  __typename?: 'TaxGraphql';
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type Tenant = {
  __typename?: 'Tenant';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mfa?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  plan?: Maybe<Scalars['String']>;
};

export type TenantAnonymous = {
  __typename?: 'TenantAnonymous';
  id: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TenantPaymentStatusGraphql = {
  __typename?: 'TenantPaymentStatusGraphql';
  paymentsEnabled: Scalars['Boolean'];
  provider: Scalars['String'];
  shouldSelectPlan: Scalars['Boolean'];
  shouldSetupPayments: Scalars['Boolean'];
};

export type TenantPlanDetailsGraphql = {
  __typename?: 'TenantPlanDetailsGraphql';
  plan?: Maybe<PlanGraphql>;
  price?: Maybe<PriceGraphql>;
  trial: Scalars['Boolean'];
  trialDaysLeft: Scalars['Float'];
};

export type UpdateNoteInput = {
  attachments?: Maybe<Array<AttachmentInput>>;
  id: Scalars['String'];
  text: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<Scalars['String']>>;
  tenantUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserInput = {
  _id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<Scalars['String']>>;
  tenantUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkspacesAnalytics = {
  __typename?: 'WorkspacesAnalytics';
  tenantId?: Maybe<Scalars['String']>;
  totalCaseNumber?: Maybe<Scalars['Float']>;
};

export type AddAnonymousMessageMutationVariables = Exact<{
  message: Scalars['String'];
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  fileUploads: Array<AddAttachmentInput>;
}>;


export type AddAnonymousMessageMutation = (
  { __typename?: 'Mutation' }
  & { addAnonymousMessage: (
    { __typename?: 'Message' }
    & Pick<Message, 'text' | 'id' | 'sender'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'id' | 'url' | 'name' | 'contentType'>
    )>> }
  ) }
);

export type AddMessageMutationVariables = Exact<{
  message: Scalars['String'];
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  fileUploads: Array<AddAttachmentInput>;
}>;


export type AddMessageMutation = (
  { __typename?: 'Mutation' }
  & { addMessage: (
    { __typename?: 'Message' }
    & Pick<Message, 'text' | 'id' | 'sender'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'id' | 'url' | 'name' | 'contentType'>
    )>> }
  ) }
);

export type AddNoteMutationVariables = Exact<{
  addNoteInput: AddNoteInput;
}>;


export type AddNoteMutation = (
  { __typename?: 'Mutation' }
  & { addNoteToIncident: (
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text' | 'createdAt' | 'updatedAt'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'fullName'>
    )>, attachments?: Maybe<Array<(
      { __typename?: 'NestedAttachment' }
      & Pick<NestedAttachment, 'key' | 'url' | 'name' | 'contentType'>
    )>> }
  ) }
);

export type AddUsersToGroupMutationVariables = Exact<{
  group: GroupInput;
  users: Array<UserInput>;
}>;


export type AddUsersToGroupMutation = (
  { __typename?: 'Mutation' }
  & { addUsersToGroup: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'fullName' | 'tenantUserId' | 'email' | 'createdAt' | 'enabled' | 'role' | 'teams'>
  )> }
);

export type CreateAnonymousIncidentMutationVariables = Exact<{
  tags: Array<TagInput>;
  submissions: Array<SubmissionInput>;
  firstMessage: Scalars['String'];
  reporterPhone?: Maybe<Scalars['String']>;
  restrictedUsers: Array<RestrictedUserInput>;
}>;


export type CreateAnonymousIncidentMutation = (
  { __typename?: 'Mutation' }
  & { createAnonymousIncident: (
    { __typename?: 'CreateIncidentResponse' }
    & Pick<CreateIncidentResponse, 'viewPassword'>
    & { incident: (
      { __typename?: 'Incident' }
      & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt'>
      & { restrictedUsers?: Maybe<Array<(
        { __typename?: 'RestrictedUser' }
        & Pick<RestrictedUser, 'id' | 'fullName'>
      )>>, tags?: Maybe<Array<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'label' | 'category'>
      )>>, submissions?: Maybe<Array<(
        { __typename?: 'Submission' }
        & Pick<Submission, 'answer' | 'question'>
        & { attachments?: Maybe<Array<(
          { __typename?: 'NestedAttachment' }
          & Pick<NestedAttachment, 'url' | 'name' | 'contentType'>
        )>> }
      )>> }
    ) }
  ) }
);

export type CreateCategoryMutationVariables = Exact<{
  category: TagInput;
}>;


export type CreateCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createCategory: (
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'active' | 'language' | 'order' | 'category'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  ) }
);

export type CreateDocumentTextMutationVariables = Exact<{
  createDocumentTextInput: Array<DocumentTextInput>;
}>;


export type CreateDocumentTextMutation = (
  { __typename?: 'Mutation' }
  & { createDocumentText: (
    { __typename?: 'DocumentText' }
    & Pick<DocumentText, 'id' | 'type' | 'language' | 'text' | 'edited' | 'isFirstTimeEdit' | 'createdAt' | 'updatedAt'>
  ) }
);

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateGroupMutation = (
  { __typename?: 'Mutation' }
  & { createGroup: (
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name' | 'createdAt'>
  ) }
);

export type CreateIncidentMutationVariables = Exact<{
  tags: Array<TagInput>;
  submissions: Array<SubmissionInput>;
  firstMessage: Scalars['String'];
}>;


export type CreateIncidentMutation = (
  { __typename?: 'Mutation' }
  & { createIncident: (
    { __typename?: 'CreateIncidentResponse' }
    & Pick<CreateIncidentResponse, 'viewPassword'>
    & { incident: (
      { __typename?: 'Incident' }
      & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt'>
      & { restrictedUsers?: Maybe<Array<(
        { __typename?: 'RestrictedUser' }
        & Pick<RestrictedUser, 'id' | 'fullName'>
      )>>, tags?: Maybe<Array<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'label' | 'category'>
      )>>, submissions?: Maybe<Array<(
        { __typename?: 'Submission' }
        & Pick<Submission, 'answer' | 'question'>
        & { attachments?: Maybe<Array<(
          { __typename?: 'NestedAttachment' }
          & Pick<NestedAttachment, 'url' | 'name' | 'contentType'>
        )>> }
      )>> }
    ) }
  ) }
);

export type CreateUsersMutationVariables = Exact<{
  userNames: Array<Scalars['String']>;
}>;


export type CreateUsersMutation = (
  { __typename?: 'Mutation' }
  & { createUsers: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'fullName' | 'email' | 'role' | 'createdAt' | 'updatedAt' | 'enabled' | 'tenantUserId' | 'teams'>
  )> }
);

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteGroupMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteGroup'>
);

export type DeleteNoteMutationVariables = Exact<{
  noteId: Scalars['String'];
}>;


export type DeleteNoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteNote'>
);

export type DeleteTagMutationVariables = Exact<{
  tag: TagInput;
}>;


export type DeleteTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteTag'>
);

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteUser'>
);

export type ExportIncidentQueryVariables = Exact<{
  caseId: Scalars['String'];
  incidentId: Scalars['String'];
  exportItems: IncidentExportItemsInput;
}>;


export type ExportIncidentQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'exportIncident'>
);

export type GetAllDocumentTextForTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDocumentTextForTenantQuery = (
  { __typename?: 'Query' }
  & { getAllDocumentTextForTenant: Array<(
    { __typename?: 'DocumentText' }
    & Pick<DocumentText, 'id' | 'type' | 'language' | 'text' | 'edited' | 'isFirstTimeEdit' | 'createdAt' | 'updatedAt'>
  )> }
);

export type GetAllDocumentTextForTenantAnonymousQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type GetAllDocumentTextForTenantAnonymousQuery = (
  { __typename?: 'Query' }
  & { getAllDocumentTextForTenantAnonymous: Array<(
    { __typename?: 'DocumentText' }
    & Pick<DocumentText, 'id' | 'type' | 'language' | 'text' | 'edited' | 'isFirstTimeEdit' | 'createdAt' | 'updatedAt'>
  )> }
);

export type GetAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticsQuery = (
  { __typename?: 'Query' }
  & { getAnalytics: Array<(
    { __typename?: 'Analytics' }
    & Pick<Analytics, 'status' | 'fraud' | 'deleted' | 'createdAt' | 'timeToFirstReadHours' | 'timeToCloseHours' | 'firstRead' | 'deletedAt'>
    & { tags?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'label'>
    )>>, assignees?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'tenantUserId' | 'id'>
    )>> }
  )> }
);

export type GetAnalyticsProcessedDataQueryVariables = Exact<{
  type: Scalars['String'];
  isExtended: Scalars['Boolean'];
  tenantIds: Array<Scalars['String']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
}>;


export type GetAnalyticsProcessedDataQuery = (
  { __typename?: 'Query' }
  & { getAnalyticsProcessedData: (
    { __typename?: 'AnalyticsProcessedDataResponse' }
    & { dashboard?: Maybe<(
      { __typename?: 'DashboardAnalytics' }
      & Pick<DashboardAnalytics, 'openCases' | 'deadlineCases' | 'avTimeRead' | 'avTimeHandling' | 'casesWithinDeadline'>
    )>, performance?: Maybe<Array<(
      { __typename?: 'PerformanceAnalytics' }
      & Pick<PerformanceAnalytics, 'year' | 'totalCaseNumber' | 'avTimeRead' | 'avTimeHandling' | 'casesWithinDeadline'>
    )>>, casesByMonths?: Maybe<Array<(
      { __typename?: 'CasesByMonthsAnalytics' }
      & Pick<CasesByMonthsAnalytics, 'year' | 'monthOrder' | 'monthNumber' | 'totalCaseNumber'>
    )>>, categories?: Maybe<Array<(
      { __typename?: 'CategoriesAnalytics' }
      & Pick<CategoriesAnalytics, 'categoryId' | 'categoryName' | 'totalCaseNumber'>
    )>>, groups?: Maybe<Array<(
      { __typename?: 'GroupsAnalytics' }
      & Pick<GroupsAnalytics, 'groupId' | 'groupName' | 'totalCaseNumber'>
    )>>, workspaces?: Maybe<Array<(
      { __typename?: 'WorkspacesAnalytics' }
      & Pick<WorkspacesAnalytics, 'tenantId' | 'totalCaseNumber'>
    )>> }
  ) }
);

export type GetAttachmentsByIncidentIdQueryVariables = Exact<{
  incidentId: Scalars['String'];
}>;


export type GetAttachmentsByIncidentIdQuery = (
  { __typename?: 'Query' }
  & { getAttachmentsByIncidentId: Array<(
    { __typename?: 'Attachment' }
    & Pick<Attachment, 'id' | 'url' | 'name' | 'contentType' | 'createdAt'>
  )> }
);

export type GetAuditLogQueryVariables = Exact<{
  incidentId: Scalars['String'];
}>;


export type GetAuditLogQuery = (
  { __typename?: 'Query' }
  & { getAuditLog: Array<(
    { __typename?: 'AuditTrailResponse' }
    & Pick<AuditTrailResponse, 'id' | 'createdAt' | 'parentId' | 'eventType' | 'objectId' | 'className'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'email' | 'fullName'>
    )>, changes?: Maybe<Array<(
      { __typename?: 'AuditChange' }
      & Pick<AuditChange, 'property' | 'event' | 'metaData'>
    )>> }
  )> }
);

export type GetCustomerPortalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerPortalQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getCustomerPortal'>
);

export type GetIncidentByCaseIdQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type GetIncidentByCaseIdQuery = (
  { __typename?: 'Query' }
  & { getIncidentByCaseId: (
    { __typename?: 'Incident' }
    & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt' | 'firstRead' | 'isSpam' | 'readByMe'>
    & { assignees?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'tenantUserId' | 'id'>
    )>>, restrictedUsers?: Maybe<Array<(
      { __typename?: 'RestrictedUser' }
      & Pick<RestrictedUser, 'id' | 'fullName'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'label' | 'category' | 'createdAt' | 'updatedAt'>
    )>>, submissions?: Maybe<Array<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'answer' | 'question'>
      & { attachments?: Maybe<Array<(
        { __typename?: 'NestedAttachment' }
        & Pick<NestedAttachment, 'url' | 'name' | 'contentType'>
      )>> }
    )>> }
  ) }
);

export type GetIncidentByOneTimeCodeAndCaseIdQueryVariables = Exact<{
  oneTimeCode: Scalars['String'];
  caseId: Scalars['String'];
}>;


export type GetIncidentByOneTimeCodeAndCaseIdQuery = (
  { __typename?: 'Query' }
  & { getIncidentByOneTimeCodeAndCaseId: (
    { __typename?: 'Incident' }
    & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt'>
    & { assignees?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'tenantUserId' | 'id'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'label' | 'category' | 'createdAt' | 'updatedAt'>
    )>>, submissions?: Maybe<Array<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'answer' | 'question'>
      & { attachments?: Maybe<Array<(
        { __typename?: 'NestedAttachment' }
        & Pick<NestedAttachment, 'url' | 'name' | 'contentType'>
      )>> }
    )>> }
  ) }
);

export type GetMessagesByIncidentIdQueryVariables = Exact<{
  incidentId: Scalars['String'];
}>;


export type GetMessagesByIncidentIdQuery = (
  { __typename?: 'Query' }
  & { getMessagesByIncidentId: Array<(
    { __typename?: 'Message' }
    & Pick<Message, 'text' | 'sender' | 'id' | 'type' | 'readByMe'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'id' | 'url' | 'name' | 'contentType'>
    )>> }
  )> }
);

export type GetMessagesByOneTimeCodeAndCaseIdQueryVariables = Exact<{
  oneTimeCode: Scalars['String'];
  caseId: Scalars['String'];
}>;


export type GetMessagesByOneTimeCodeAndCaseIdQuery = (
  { __typename?: 'Query' }
  & { getMessagesByOneTimeCodeAndCaseId: Array<(
    { __typename?: 'Message' }
    & Pick<Message, 'text' | 'sender' | 'id' | 'type'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'id' | 'url' | 'name' | 'contentType'>
    )>> }
  )> }
);

export type GetNotesByIncidentIdQueryVariables = Exact<{
  incidentId: Scalars['String'];
}>;


export type GetNotesByIncidentIdQuery = (
  { __typename?: 'Query' }
  & { getNotesByIncidentId: Array<(
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text' | 'createdAt' | 'updatedAt'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'NestedAttachment' }
      & Pick<NestedAttachment, 'url' | 'key' | 'name' | 'contentType'>
    )>>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'fullName'>
    )> }
  )> }
);

export type GetOneTimeCodeForIncidentByPasswordQueryVariables = Exact<{
  caseId: Scalars['String'];
  password: Scalars['String'];
}>;


export type GetOneTimeCodeForIncidentByPasswordQuery = (
  { __typename?: 'Query' }
  & { getOneTimeCodeForIncidentByPassword: (
    { __typename?: 'OneTimeCode' }
    & Pick<OneTimeCode, 'id' | 'code'>
  ) }
);

export type GetOneTimeCodeForIncidentByPhoneQueryVariables = Exact<{
  caseId: Scalars['String'];
  reporterPhone: Scalars['String'];
}>;


export type GetOneTimeCodeForIncidentByPhoneQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getOneTimeCodeForIncidentByPhone'>
);

export type GetReporterEnabledLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReporterEnabledLanguagesQuery = (
  { __typename?: 'Query' }
  & { getReporterEnabledLanguages: Array<(
    { __typename?: 'ReporterLanguage' }
    & Pick<ReporterLanguage, 'label' | 'value'>
  )> }
);

export type GetReporterSettingsAnonymousQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type GetReporterSettingsAnonymousQuery = (
  { __typename?: 'Query' }
  & { getReporterSettingsAnonymous: (
    { __typename?: 'ReporterSettings' }
    & Pick<ReporterSettings, 'phoneHotlineNumber' | 'type' | 'loginType' | 'companyLogo' | 'companyName' | 'dataProtectionOfficer' | 'responsiblePersonForWhistleblowing'>
    & { brandColor?: Maybe<(
      { __typename?: 'ReporterBrandColor' }
      & Pick<ReporterBrandColor, 'header' | 'headerText' | 'button' | 'buttonText' | 'link'>
    )>, languages?: Maybe<Array<(
      { __typename?: 'ReporterLanguage' }
      & Pick<ReporterLanguage, 'label' | 'value'>
    )>>, hidePersonalDataManagementPolicyLink?: Maybe<Array<(
      { __typename?: 'HidePersonalDataManagementPolicyLink' }
      & Pick<HidePersonalDataManagementPolicyLink, 'language' | 'value'>
    )>> }
  ) }
);

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = (
  { __typename?: 'Query' }
  & { getSettings: (
    { __typename?: 'Settings' }
    & Pick<Settings, 'id'>
    & { linkedTenants?: Maybe<Array<(
      { __typename?: 'LinkedTenants' }
      & Pick<LinkedTenants, 'tenantId' | 'name'>
    )>>, reporter: (
      { __typename?: 'ReporterSettings' }
      & Pick<ReporterSettings, 'phoneHotlineNumber' | 'type' | 'loginType' | 'companyLogo' | 'companyName' | 'dataProtectionOfficer' | 'responsiblePersonForWhistleblowing'>
      & { brandColor?: Maybe<(
        { __typename?: 'ReporterBrandColor' }
        & Pick<ReporterBrandColor, 'header' | 'headerText' | 'button' | 'buttonText' | 'link'>
      )>, languages?: Maybe<Array<(
        { __typename?: 'ReporterLanguage' }
        & Pick<ReporterLanguage, 'label' | 'value'>
      )>>, hidePersonalDataManagementPolicyLink?: Maybe<Array<(
        { __typename?: 'HidePersonalDataManagementPolicyLink' }
        & Pick<HidePersonalDataManagementPolicyLink, 'language' | 'value'>
      )>> }
    ) }
  ) }
);

export type GetTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantQuery = (
  { __typename?: 'Query' }
  & { getTenant: (
    { __typename?: 'Tenant' }
    & Pick<Tenant, 'id' | 'name' | 'logo' | 'locale' | 'plan' | 'mfa' | 'createdAt'>
  ) }
);

export type GetTenantAnonymousQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantAnonymousQuery = (
  { __typename?: 'Query' }
  & { getTenantAnonymous: (
    { __typename?: 'TenantAnonymous' }
    & Pick<TenantAnonymous, 'id' | 'name' | 'locale' | 'logo'>
  ) }
);

export type IncidentSetStatusWithMessageMutationVariables = Exact<{
  message: Scalars['String'];
  incidentId: Scalars['String'];
  sender: Scalars['String'];
  status: Status;
}>;


export type IncidentSetStatusWithMessageMutation = (
  { __typename?: 'Mutation' }
  & { incidentSetStatusWithMessage: (
    { __typename?: 'IncidentWithMessage' }
    & { incident: (
      { __typename?: 'Incident' }
      & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt'>
    ), message: (
      { __typename?: 'Message' }
      & Pick<Message, 'text' | 'id' | 'sender'>
    ) }
  ) }
);

export type ListActiveCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListActiveCategoriesQuery = (
  { __typename?: 'Query' }
  & { listActiveCategories: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'order' | 'language' | 'active' | 'category'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  )> }
);

export type ListActiveCategoriesAnonymousQueryVariables = Exact<{ [key: string]: never; }>;


export type ListActiveCategoriesAnonymousQuery = (
  { __typename?: 'Query' }
  & { listActiveCategoriesAnonymous: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'order' | 'language' | 'active' | 'category'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  )> }
);

export type ListCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCategoriesQuery = (
  { __typename?: 'Query' }
  & { listCategories: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'order' | 'language' | 'active' | 'category' | 'unchangeable'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  )> }
);

export type ListCategoriesAnonymousQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCategoriesAnonymousQuery = (
  { __typename?: 'Query' }
  & { listCategoriesAnonymous: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'order' | 'language' | 'active' | 'category' | 'unchangeable'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  )> }
);

export type ListGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGroupsQuery = (
  { __typename?: 'Query' }
  & { listGroups: Array<(
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name' | 'createdAt'>
    & { categoryRouting?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'label'>
    )>> }
  )> }
);

export type ListIncidentsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  categoryIds?: Maybe<Array<Scalars['String']>>;
}>;


export type ListIncidentsQuery = (
  { __typename?: 'Query' }
  & { listIncidents: Array<(
    { __typename?: 'Incident' }
    & Pick<Incident, 'id' | 'caseId' | 'status' | 'firstMessage' | 'createdAt' | 'updatedAt' | 'isSpam' | 'readByMe'>
  )> }
);

export type ListRedirectRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRedirectRulesQuery = (
  { __typename?: 'Query' }
  & { listRedirectRules: Array<(
    { __typename?: 'RedirectRuleGraphql' }
    & Pick<RedirectRuleGraphql, 'id' | 'phoneNumber' | 'anonymous'>
    & { targets?: Maybe<Array<(
      { __typename?: 'RedirectTargetGrapqh' }
      & Pick<RedirectTargetGrapqh, 'phoneNumber' | 'name' | 'available'>
    )>> }
  )> }
);

export type ListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersQuery = (
  { __typename?: 'Query' }
  & { listUsers: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'fullName' | 'tenantUserId' | 'email' | 'createdAt' | 'enabled' | 'role' | 'teams'>
  )> }
);

export type ListUsersAnonymousQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersAnonymousQuery = (
  { __typename?: 'Query' }
  & { listUsersAnonymous: Array<(
    { __typename?: 'RestrictedUser' }
    & Pick<RestrictedUser, 'id' | 'fullName'>
  )> }
);

export type ResetToDefaultCategoriesInLanguageMutationVariables = Exact<{
  language: ReporterLanguageInput;
}>;


export type ResetToDefaultCategoriesInLanguageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetToDefaultCategoriesInLanguage'>
);

export type SendPasswordResetLinkMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SendPasswordResetLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendPasswordResetLink'>
);

export type TranslateMessageQueryVariables = Exact<{
  message: Scalars['String'];
}>;


export type TranslateMessageQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'translateMessage'>
);

export type TranslateMessageAnonymousQueryVariables = Exact<{
  message: Scalars['String'];
}>;


export type TranslateMessageAnonymousQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'translateMessageAnonymous'>
);

export type UpdateAssigneesMutationVariables = Exact<{
  incidentId: Scalars['String'];
  assignees: Array<UserInput>;
}>;


export type UpdateAssigneesMutation = (
  { __typename?: 'Mutation' }
  & { updateAssignees: (
    { __typename?: 'Incident' }
    & Pick<Incident, 'id' | 'caseId' | 'status' | 'createdAt' | 'updatedAt'>
    & { assignees?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'tenantUserId' | 'id' | 'teams'>
    )>>, tags?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'label' | 'category' | 'createdAt' | 'updatedAt'>
    )>> }
  ) }
);

export type UpdateDocumentTextMutationVariables = Exact<{
  updateDocumentTextInput: DocumentTextInput;
}>;


export type UpdateDocumentTextMutation = (
  { __typename?: 'Mutation' }
  & { updateDocumentText: (
    { __typename?: 'DocumentText' }
    & Pick<DocumentText, 'id' | 'type' | 'language' | 'text' | 'edited' | 'isFirstTimeEdit' | 'createdAt' | 'updatedAt'>
  ) }
);

export type UpdateGroupMutationVariables = Exact<{
  group: GroupInput;
}>;


export type UpdateGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateGroup: (
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name' | 'createdAt'>
    & { categoryRouting?: Maybe<Array<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'label'>
    )>> }
  ) }
);

export type UpdateNoteMutationVariables = Exact<{
  noteInput: UpdateNoteInput;
}>;


export type UpdateNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateNote: (
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text' | 'createdAt' | 'updatedAt'>
    & { attachments?: Maybe<Array<(
      { __typename?: 'NestedAttachment' }
      & Pick<NestedAttachment, 'url' | 'name' | 'contentType'>
    )>>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'fullName'>
    )> }
  ) }
);

export type UpdateRedirectRuleMutationVariables = Exact<{
  redirectRule: RedirectRuleGraphqlInput;
}>;


export type UpdateRedirectRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateRedirectRule: (
    { __typename?: 'RedirectRuleGraphql' }
    & Pick<RedirectRuleGraphql, 'id' | 'phoneNumber' | 'anonymous'>
    & { targets?: Maybe<Array<(
      { __typename?: 'RedirectTargetGrapqh' }
      & Pick<RedirectTargetGrapqh, 'phoneNumber' | 'name' | 'available'>
    )>> }
  ) }
);

export type UpdateReporterSettingsMutationVariables = Exact<{
  reporterSettings: ReporterSettingsInput;
}>;


export type UpdateReporterSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateReporterSettings: (
    { __typename?: 'ReporterSettings' }
    & Pick<ReporterSettings, 'phoneHotlineNumber' | 'type' | 'loginType' | 'companyLogo' | 'companyName' | 'dataProtectionOfficer' | 'responsiblePersonForWhistleblowing'>
    & { brandColor?: Maybe<(
      { __typename?: 'ReporterBrandColor' }
      & Pick<ReporterBrandColor, 'header' | 'headerText' | 'button' | 'buttonText' | 'link'>
    )>, languages?: Maybe<Array<(
      { __typename?: 'ReporterLanguage' }
      & Pick<ReporterLanguage, 'label' | 'value'>
    )>>, hidePersonalDataManagementPolicyLink?: Maybe<Array<(
      { __typename?: 'HidePersonalDataManagementPolicyLink' }
      & Pick<HidePersonalDataManagementPolicyLink, 'language' | 'value'>
    )>> }
  ) }
);

export type UpdateTagMutationVariables = Exact<{
  tag: TagInput;
}>;


export type UpdateTagMutation = (
  { __typename?: 'Mutation' }
  & { updateTag: (
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'label' | 'active' | 'order' | 'category' | 'language'>
    & { conversationalFlow?: Maybe<Array<(
      { __typename?: 'ConversationEntry' }
      & Pick<ConversationEntry, 'botText' | 'type'>
    )>> }
  ) }
);

export type UpdateTenantMutationVariables = Exact<{
  name: Scalars['String'];
  locale: Scalars['String'];
  mfa?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateTenantMutation = (
  { __typename?: 'Mutation' }
  & { updateTenant: (
    { __typename?: 'Tenant' }
    & Pick<Tenant, 'id' | 'name' | 'logo' | 'mfa' | 'locale' | 'plan' | 'createdAt'>
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'fullName' | 'email' | 'role' | 'createdAt' | 'updatedAt' | 'enabled' | 'tenantUserId' | 'teams'>
  ) }
);

export const AddAnonymousMessageDocument = gql`
    mutation AddAnonymousMessage($message: String!, $incidentId: String!, $sender: String!, $fileUploads: [AddAttachmentInput!]!) {
  addAnonymousMessage(text: $message, incidentId: $incidentId, sender: $sender, fileUploads: $fileUploads) {
    text
    id
    sender
    attachments {
      id
      url
      name
      contentType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAnonymousMessageGQL extends Apollo.Mutation<AddAnonymousMessageMutation, AddAnonymousMessageMutationVariables> {
    document = AddAnonymousMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMessageDocument = gql`
    mutation AddMessage($message: String!, $incidentId: String!, $sender: String!, $fileUploads: [AddAttachmentInput!]!) {
  addMessage(text: $message, incidentId: $incidentId, sender: $sender, fileUploads: $fileUploads) {
    text
    id
    sender
    attachments {
      id
      url
      name
      contentType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMessageGQL extends Apollo.Mutation<AddMessageMutation, AddMessageMutationVariables> {
    document = AddMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNoteDocument = gql`
    mutation AddNote($addNoteInput: AddNoteInput!) {
  addNoteToIncident(addNoteInput: $addNoteInput) {
    id
    text
    createdAt
    updatedAt
    user {
      id
      email
      fullName
    }
    attachments {
      key
      url
      name
      contentType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNoteGQL extends Apollo.Mutation<AddNoteMutation, AddNoteMutationVariables> {
    document = AddNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUsersToGroupDocument = gql`
    mutation AddUsersToGroup($group: GroupInput!, $users: [UserInput!]!) {
  addUsersToGroup(group: $group, users: $users) {
    id
    fullName
    tenantUserId
    email
    createdAt
    enabled
    role
    teams
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUsersToGroupGQL extends Apollo.Mutation<AddUsersToGroupMutation, AddUsersToGroupMutationVariables> {
    document = AddUsersToGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAnonymousIncidentDocument = gql`
    mutation CreateAnonymousIncident($tags: [TagInput!]!, $submissions: [SubmissionInput!]!, $firstMessage: String!, $reporterPhone: String, $restrictedUsers: [RestrictedUserInput!]!) {
  createAnonymousIncident(tags: $tags, submissions: $submissions, firstMessage: $firstMessage, reporterPhone: $reporterPhone, restrictedUsers: $restrictedUsers) {
    incident {
      id
      caseId
      status
      firstMessage
      createdAt
      updatedAt
      restrictedUsers {
        id
        fullName
      }
      tags {
        label
        category
      }
      submissions {
        answer
        attachments {
          url
          name
          contentType
        }
        question
      }
    }
    viewPassword
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAnonymousIncidentGQL extends Apollo.Mutation<CreateAnonymousIncidentMutation, CreateAnonymousIncidentMutationVariables> {
    document = CreateAnonymousIncidentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCategoryDocument = gql`
    mutation CreateCategory($category: TagInput!) {
  createCategory(category: $category) {
    id
    label
    active
    language
    order
    category
    conversationalFlow {
      botText
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCategoryGQL extends Apollo.Mutation<CreateCategoryMutation, CreateCategoryMutationVariables> {
    document = CreateCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentTextDocument = gql`
    mutation CreateDocumentText($createDocumentTextInput: [DocumentTextInput!]!) {
  createDocumentText(createDocumentTextInput: $createDocumentTextInput) {
    id
    type
    language
    text
    edited
    isFirstTimeEdit
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentTextGQL extends Apollo.Mutation<CreateDocumentTextMutation, CreateDocumentTextMutationVariables> {
    document = CreateDocumentTextDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGroupDocument = gql`
    mutation CreateGroup($name: String!) {
  createGroup(name: $name) {
    id
    name
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGroupGQL extends Apollo.Mutation<CreateGroupMutation, CreateGroupMutationVariables> {
    document = CreateGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIncidentDocument = gql`
    mutation CreateIncident($tags: [TagInput!]!, $submissions: [SubmissionInput!]!, $firstMessage: String!) {
  createIncident(tags: $tags, submissions: $submissions, firstMessage: $firstMessage) {
    incident {
      id
      caseId
      status
      firstMessage
      createdAt
      updatedAt
      restrictedUsers {
        id
        fullName
      }
      tags {
        label
        category
      }
      submissions {
        answer
        attachments {
          url
          name
          contentType
        }
        question
      }
    }
    viewPassword
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIncidentGQL extends Apollo.Mutation<CreateIncidentMutation, CreateIncidentMutationVariables> {
    document = CreateIncidentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUsersDocument = gql`
    mutation CreateUsers($userNames: [String!]!) {
  createUsers(userNames: $userNames) {
    id
    fullName
    email
    role
    createdAt
    updatedAt
    enabled
    tenantUserId
    teams
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUsersGQL extends Apollo.Mutation<CreateUsersMutation, CreateUsersMutationVariables> {
    document = CreateUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($id: String!) {
  deleteGroup(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGroupGQL extends Apollo.Mutation<DeleteGroupMutation, DeleteGroupMutationVariables> {
    document = DeleteGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNoteDocument = gql`
    mutation DeleteNote($noteId: String!) {
  deleteNote(noteId: $noteId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNoteGQL extends Apollo.Mutation<DeleteNoteMutation, DeleteNoteMutationVariables> {
    document = DeleteNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTagDocument = gql`
    mutation DeleteTag($tag: TagInput!) {
  deleteTag(tag: $tag)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTagGQL extends Apollo.Mutation<DeleteTagMutation, DeleteTagMutationVariables> {
    document = DeleteTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation DeleteUser($userId: String!) {
  deleteUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportIncidentDocument = gql`
    query ExportIncident($caseId: String!, $incidentId: String!, $exportItems: IncidentExportItemsInput!) {
  exportIncident(caseId: $caseId, incidentId: $incidentId, exportItems: $exportItems)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportIncidentGQL extends Apollo.Query<ExportIncidentQuery, ExportIncidentQueryVariables> {
    document = ExportIncidentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDocumentTextForTenantDocument = gql`
    query GetAllDocumentTextForTenant {
  getAllDocumentTextForTenant {
    id
    type
    language
    text
    edited
    isFirstTimeEdit
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDocumentTextForTenantGQL extends Apollo.Query<GetAllDocumentTextForTenantQuery, GetAllDocumentTextForTenantQueryVariables> {
    document = GetAllDocumentTextForTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDocumentTextForTenantAnonymousDocument = gql`
    query GetAllDocumentTextForTenantAnonymous($tenantId: String!) {
  getAllDocumentTextForTenantAnonymous(tenantId: $tenantId) {
    id
    type
    language
    text
    edited
    isFirstTimeEdit
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDocumentTextForTenantAnonymousGQL extends Apollo.Query<GetAllDocumentTextForTenantAnonymousQuery, GetAllDocumentTextForTenantAnonymousQueryVariables> {
    document = GetAllDocumentTextForTenantAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnalyticsDocument = gql`
    query GetAnalytics {
  getAnalytics {
    status
    tags {
      id
      label
    }
    assignees {
      fullName
      tenantUserId
      id
    }
    fraud
    deleted
    createdAt
    timeToFirstReadHours
    timeToCloseHours
    firstRead
    deletedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnalyticsGQL extends Apollo.Query<GetAnalyticsQuery, GetAnalyticsQueryVariables> {
    document = GetAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnalyticsProcessedDataDocument = gql`
    query GetAnalyticsProcessedData($type: String!, $isExtended: Boolean!, $tenantIds: [String!]!, $dateFrom: String!, $dateTo: String!) {
  getAnalyticsProcessedData(type: $type, isExtended: $isExtended, tenantIds: $tenantIds, dateFrom: $dateFrom, dateTo: $dateTo) {
    dashboard {
      openCases
      deadlineCases
      avTimeRead
      avTimeHandling
      casesWithinDeadline
    }
    performance {
      year
      totalCaseNumber
      avTimeRead
      avTimeHandling
      casesWithinDeadline
    }
    casesByMonths {
      year
      monthOrder
      monthNumber
      totalCaseNumber
    }
    categories {
      categoryId
      categoryName
      totalCaseNumber
    }
    groups {
      groupId
      groupName
      totalCaseNumber
    }
    workspaces {
      tenantId
      totalCaseNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnalyticsProcessedDataGQL extends Apollo.Query<GetAnalyticsProcessedDataQuery, GetAnalyticsProcessedDataQueryVariables> {
    document = GetAnalyticsProcessedDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttachmentsByIncidentIdDocument = gql`
    query getAttachmentsByIncidentId($incidentId: String!) {
  getAttachmentsByIncidentId(incidentId: $incidentId) {
    id
    url
    name
    contentType
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttachmentsByIncidentIdGQL extends Apollo.Query<GetAttachmentsByIncidentIdQuery, GetAttachmentsByIncidentIdQueryVariables> {
    document = GetAttachmentsByIncidentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuditLogDocument = gql`
    query GetAuditLog($incidentId: String!) {
  getAuditLog(incidentId: $incidentId) {
    id
    createdAt
    parentId
    eventType
    objectId
    className
    user {
      email
      fullName
    }
    changes {
      property
      event
      metaData
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuditLogGQL extends Apollo.Query<GetAuditLogQuery, GetAuditLogQueryVariables> {
    document = GetAuditLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerPortalDocument = gql`
    query GetCustomerPortal {
  getCustomerPortal
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomerPortalGQL extends Apollo.Query<GetCustomerPortalQuery, GetCustomerPortalQueryVariables> {
    document = GetCustomerPortalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIncidentByCaseIdDocument = gql`
    query GetIncidentByCaseId($caseId: String!) {
  getIncidentByCaseId(caseId: $caseId) {
    id
    caseId
    status
    firstMessage
    createdAt
    updatedAt
    firstRead
    isSpam
    readByMe
    assignees {
      fullName
      tenantUserId
      id
    }
    restrictedUsers {
      id
      fullName
    }
    tags {
      label
      category
      createdAt
      updatedAt
    }
    submissions {
      answer
      attachments {
        url
        name
        contentType
      }
      question
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIncidentByCaseIdGQL extends Apollo.Query<GetIncidentByCaseIdQuery, GetIncidentByCaseIdQueryVariables> {
    document = GetIncidentByCaseIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIncidentByOneTimeCodeAndCaseIdDocument = gql`
    query GetIncidentByOneTimeCodeAndCaseId($oneTimeCode: String!, $caseId: String!) {
  getIncidentByOneTimeCodeAndCaseId(oneTimeCode: $oneTimeCode, caseId: $caseId) {
    id
    caseId
    status
    firstMessage
    createdAt
    updatedAt
    assignees {
      fullName
      tenantUserId
      id
    }
    tags {
      label
      category
      createdAt
      updatedAt
    }
    submissions {
      answer
      attachments {
        url
        name
        contentType
      }
      question
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIncidentByOneTimeCodeAndCaseIdGQL extends Apollo.Query<GetIncidentByOneTimeCodeAndCaseIdQuery, GetIncidentByOneTimeCodeAndCaseIdQueryVariables> {
    document = GetIncidentByOneTimeCodeAndCaseIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMessagesByIncidentIdDocument = gql`
    query getMessagesByIncidentId($incidentId: String!) {
  getMessagesByIncidentId(incidentId: $incidentId) {
    text
    sender
    id
    type
    readByMe
    attachments {
      id
      url
      name
      contentType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMessagesByIncidentIdGQL extends Apollo.Query<GetMessagesByIncidentIdQuery, GetMessagesByIncidentIdQueryVariables> {
    document = GetMessagesByIncidentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMessagesByOneTimeCodeAndCaseIdDocument = gql`
    query getMessagesByOneTimeCodeAndCaseId($oneTimeCode: String!, $caseId: String!) {
  getMessagesByOneTimeCodeAndCaseId(oneTimeCode: $oneTimeCode, caseId: $caseId) {
    text
    sender
    id
    type
    attachments {
      id
      url
      name
      contentType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMessagesByOneTimeCodeAndCaseIdGQL extends Apollo.Query<GetMessagesByOneTimeCodeAndCaseIdQuery, GetMessagesByOneTimeCodeAndCaseIdQueryVariables> {
    document = GetMessagesByOneTimeCodeAndCaseIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotesByIncidentIdDocument = gql`
    query GetNotesByIncidentId($incidentId: String!) {
  getNotesByIncidentId(incidentId: $incidentId) {
    id
    text
    attachments {
      url
      key
      name
      contentType
    }
    user {
      fullName
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotesByIncidentIdGQL extends Apollo.Query<GetNotesByIncidentIdQuery, GetNotesByIncidentIdQueryVariables> {
    document = GetNotesByIncidentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOneTimeCodeForIncidentByPasswordDocument = gql`
    query GetOneTimeCodeForIncidentByPassword($caseId: String!, $password: String!) {
  getOneTimeCodeForIncidentByPassword(caseId: $caseId, password: $password) {
    id
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOneTimeCodeForIncidentByPasswordGQL extends Apollo.Query<GetOneTimeCodeForIncidentByPasswordQuery, GetOneTimeCodeForIncidentByPasswordQueryVariables> {
    document = GetOneTimeCodeForIncidentByPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOneTimeCodeForIncidentByPhoneDocument = gql`
    query GetOneTimeCodeForIncidentByPhone($caseId: String!, $reporterPhone: String!) {
  getOneTimeCodeForIncidentByPhone(caseId: $caseId, reporterPhone: $reporterPhone)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOneTimeCodeForIncidentByPhoneGQL extends Apollo.Query<GetOneTimeCodeForIncidentByPhoneQuery, GetOneTimeCodeForIncidentByPhoneQueryVariables> {
    document = GetOneTimeCodeForIncidentByPhoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReporterEnabledLanguagesDocument = gql`
    query GetReporterEnabledLanguages {
  getReporterEnabledLanguages {
    label
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReporterEnabledLanguagesGQL extends Apollo.Query<GetReporterEnabledLanguagesQuery, GetReporterEnabledLanguagesQueryVariables> {
    document = GetReporterEnabledLanguagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReporterSettingsAnonymousDocument = gql`
    query GetReporterSettingsAnonymous($tenantId: String!) {
  getReporterSettingsAnonymous(tenantId: $tenantId) {
    phoneHotlineNumber
    type
    loginType
    brandColor {
      header
      headerText
      button
      buttonText
      link
    }
    companyLogo
    companyName
    dataProtectionOfficer
    languages {
      label
      value
    }
    responsiblePersonForWhistleblowing
    hidePersonalDataManagementPolicyLink {
      language
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReporterSettingsAnonymousGQL extends Apollo.Query<GetReporterSettingsAnonymousQuery, GetReporterSettingsAnonymousQueryVariables> {
    document = GetReporterSettingsAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSettingsDocument = gql`
    query GetSettings {
  getSettings {
    id
    linkedTenants {
      tenantId
      name
    }
    reporter {
      phoneHotlineNumber
      type
      loginType
      brandColor {
        header
        headerText
        button
        buttonText
        link
      }
      companyLogo
      companyName
      dataProtectionOfficer
      languages {
        label
        value
      }
      responsiblePersonForWhistleblowing
      hidePersonalDataManagementPolicyLink {
        language
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSettingsGQL extends Apollo.Query<GetSettingsQuery, GetSettingsQueryVariables> {
    document = GetSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantDocument = gql`
    query GetTenant {
  getTenant {
    id
    name
    logo
    locale
    plan
    mfa
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantGQL extends Apollo.Query<GetTenantQuery, GetTenantQueryVariables> {
    document = GetTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantAnonymousDocument = gql`
    query GetTenantAnonymous {
  getTenantAnonymous {
    id
    name
    locale
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantAnonymousGQL extends Apollo.Query<GetTenantAnonymousQuery, GetTenantAnonymousQueryVariables> {
    document = GetTenantAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncidentSetStatusWithMessageDocument = gql`
    mutation IncidentSetStatusWithMessage($message: String!, $incidentId: String!, $sender: String!, $status: Status!) {
  incidentSetStatusWithMessage(text: $message, incidentId: $incidentId, sender: $sender, status: $status) {
    incident {
      id
      caseId
      status
      firstMessage
      createdAt
      updatedAt
    }
    message {
      text
      id
      sender
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IncidentSetStatusWithMessageGQL extends Apollo.Mutation<IncidentSetStatusWithMessageMutation, IncidentSetStatusWithMessageMutationVariables> {
    document = IncidentSetStatusWithMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListActiveCategoriesDocument = gql`
    query ListActiveCategories {
  listActiveCategories {
    id
    label
    order
    language
    active
    category
    conversationalFlow {
      botText
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListActiveCategoriesGQL extends Apollo.Query<ListActiveCategoriesQuery, ListActiveCategoriesQueryVariables> {
    document = ListActiveCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListActiveCategoriesAnonymousDocument = gql`
    query ListActiveCategoriesAnonymous {
  listActiveCategoriesAnonymous {
    id
    label
    order
    language
    active
    category
    conversationalFlow {
      botText
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListActiveCategoriesAnonymousGQL extends Apollo.Query<ListActiveCategoriesAnonymousQuery, ListActiveCategoriesAnonymousQueryVariables> {
    document = ListActiveCategoriesAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCategoriesDocument = gql`
    query ListCategories {
  listCategories {
    id
    label
    order
    language
    active
    category
    conversationalFlow {
      botText
      type
    }
    unchangeable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCategoriesGQL extends Apollo.Query<ListCategoriesQuery, ListCategoriesQueryVariables> {
    document = ListCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCategoriesAnonymousDocument = gql`
    query ListCategoriesAnonymous {
  listCategoriesAnonymous {
    id
    label
    order
    language
    active
    category
    conversationalFlow {
      botText
      type
    }
    unchangeable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCategoriesAnonymousGQL extends Apollo.Query<ListCategoriesAnonymousQuery, ListCategoriesAnonymousQueryVariables> {
    document = ListCategoriesAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListGroupsDocument = gql`
    query ListGroups {
  listGroups {
    id
    name
    categoryRouting {
      id
      label
    }
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListGroupsGQL extends Apollo.Query<ListGroupsQuery, ListGroupsQueryVariables> {
    document = ListGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListIncidentsDocument = gql`
    query ListIncidents($sort: String, $assigneeIds: [String!], $categoryIds: [String!]) {
  listIncidents(sort: $sort, assigneeIds: $assigneeIds, categoryIds: $categoryIds) {
    id
    caseId
    status
    firstMessage
    createdAt
    updatedAt
    isSpam
    readByMe
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListIncidentsGQL extends Apollo.Query<ListIncidentsQuery, ListIncidentsQueryVariables> {
    document = ListIncidentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListRedirectRulesDocument = gql`
    query ListRedirectRules {
  listRedirectRules {
    id
    phoneNumber
    targets {
      phoneNumber
      name
      available
    }
    anonymous
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListRedirectRulesGQL extends Apollo.Query<ListRedirectRulesQuery, ListRedirectRulesQueryVariables> {
    document = ListRedirectRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUsersDocument = gql`
    query ListUsers {
  listUsers {
    id
    fullName
    tenantUserId
    email
    createdAt
    enabled
    role
    teams
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUsersGQL extends Apollo.Query<ListUsersQuery, ListUsersQueryVariables> {
    document = ListUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUsersAnonymousDocument = gql`
    query ListUsersAnonymous {
  listUsersAnonymous {
    id
    fullName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUsersAnonymousGQL extends Apollo.Query<ListUsersAnonymousQuery, ListUsersAnonymousQueryVariables> {
    document = ListUsersAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetToDefaultCategoriesInLanguageDocument = gql`
    mutation ResetToDefaultCategoriesInLanguage($language: ReporterLanguageInput!) {
  resetToDefaultCategoriesInLanguage(language: $language)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetToDefaultCategoriesInLanguageGQL extends Apollo.Mutation<ResetToDefaultCategoriesInLanguageMutation, ResetToDefaultCategoriesInLanguageMutationVariables> {
    document = ResetToDefaultCategoriesInLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendPasswordResetLinkDocument = gql`
    mutation SendPasswordResetLink($userId: String!) {
  sendPasswordResetLink(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendPasswordResetLinkGQL extends Apollo.Mutation<SendPasswordResetLinkMutation, SendPasswordResetLinkMutationVariables> {
    document = SendPasswordResetLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslateMessageDocument = gql`
    query TranslateMessage($message: String!) {
  translateMessage(message: $message)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslateMessageGQL extends Apollo.Query<TranslateMessageQuery, TranslateMessageQueryVariables> {
    document = TranslateMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslateMessageAnonymousDocument = gql`
    query TranslateMessageAnonymous($message: String!) {
  translateMessageAnonymous(message: $message)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslateMessageAnonymousGQL extends Apollo.Query<TranslateMessageAnonymousQuery, TranslateMessageAnonymousQueryVariables> {
    document = TranslateMessageAnonymousDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssigneesDocument = gql`
    mutation UpdateAssignees($incidentId: String!, $assignees: [UserInput!]!) {
  updateAssignees(incidentId: $incidentId, assignees: $assignees) {
    id
    caseId
    status
    createdAt
    updatedAt
    assignees {
      fullName
      tenantUserId
      id
      teams
    }
    tags {
      label
      category
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssigneesGQL extends Apollo.Mutation<UpdateAssigneesMutation, UpdateAssigneesMutationVariables> {
    document = UpdateAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentTextDocument = gql`
    mutation UpdateDocumentText($updateDocumentTextInput: DocumentTextInput!) {
  updateDocumentText(updateDocumentTextInput: $updateDocumentTextInput) {
    id
    type
    language
    text
    edited
    isFirstTimeEdit
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentTextGQL extends Apollo.Mutation<UpdateDocumentTextMutation, UpdateDocumentTextMutationVariables> {
    document = UpdateDocumentTextDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($group: GroupInput!) {
  updateGroup(group: $group) {
    id
    name
    categoryRouting {
      id
      label
    }
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGroupGQL extends Apollo.Mutation<UpdateGroupMutation, UpdateGroupMutationVariables> {
    document = UpdateGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNoteDocument = gql`
    mutation UpdateNote($noteInput: UpdateNoteInput!) {
  updateNote(noteInput: $noteInput) {
    id
    text
    attachments {
      url
      name
      contentType
    }
    createdAt
    updatedAt
    user {
      id
      email
      fullName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNoteGQL extends Apollo.Mutation<UpdateNoteMutation, UpdateNoteMutationVariables> {
    document = UpdateNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRedirectRuleDocument = gql`
    mutation UpdateRedirectRule($redirectRule: RedirectRuleGraphqlInput!) {
  updateRedirectRule(redirectRule: $redirectRule) {
    id
    phoneNumber
    targets {
      phoneNumber
      name
      available
    }
    anonymous
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRedirectRuleGQL extends Apollo.Mutation<UpdateRedirectRuleMutation, UpdateRedirectRuleMutationVariables> {
    document = UpdateRedirectRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReporterSettingsDocument = gql`
    mutation UpdateReporterSettings($reporterSettings: ReporterSettingsInput!) {
  updateReporterSettings(reporterSettings: $reporterSettings) {
    phoneHotlineNumber
    type
    loginType
    brandColor {
      header
      headerText
      button
      buttonText
      link
    }
    companyLogo
    companyName
    dataProtectionOfficer
    responsiblePersonForWhistleblowing
    languages {
      label
      value
    }
    hidePersonalDataManagementPolicyLink {
      language
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReporterSettingsGQL extends Apollo.Mutation<UpdateReporterSettingsMutation, UpdateReporterSettingsMutationVariables> {
    document = UpdateReporterSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTagDocument = gql`
    mutation UpdateTag($tag: TagInput!) {
  updateTag(tag: $tag) {
    id
    label
    active
    order
    category
    language
    conversationalFlow {
      botText
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTagGQL extends Apollo.Mutation<UpdateTagMutation, UpdateTagMutationVariables> {
    document = UpdateTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($name: String!, $locale: String!, $mfa: Boolean) {
  updateTenant(name: $name, locale: $locale, mfa: $mfa) {
    id
    name
    logo
    mfa
    locale
    plan
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantGQL extends Apollo.Mutation<UpdateTenantMutation, UpdateTenantMutationVariables> {
    document = UpdateTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($user: UserInput!) {
  updateUser(user: $user) {
    id
    fullName
    email
    role
    createdAt
    updatedAt
    enabled
    tenantUserId
    teams
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }